import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from './UserContext';

const ProtectedRoute = ({ children, requireAuth = false, requiredRole = null }) => {
  const { user } = useUser();

  // If authentication is required but user is not logged in
  if (requireAuth && !user) {
    return <Navigate to="/" replace />;
  }

  // If specific role is required but user doesn't have it
  if (requiredRole && (!user || user.userRole !== requiredRole)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;